<template>
  <v-data-table
    :headers="header"
    :items="gruposeparacoes"
    :fixed-header="true"
    :search="search"
    :items-per-page="50"
    item-key="id"
    class="elevation-2 table-full-screen mx-1"
    :height="ALTURA_TABELA"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <div class="d-flex ml-n3">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          <p class="ma-0 subtitle-1 font-weight-medium">Grupo de Separação</p>
        </div>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          single-line
          hide-details
          clearable
          class="pr-5"
          style="max-width: 450px"
        ></v-text-field>

        <SysDialog
          v-model="dialog"
          max-width="600px"
          :titulo="title"
          @click:primary="salvar"
          @click:hidden-dialog="$v.$reset();fechar();"
        >
          <template #ativador>
            <v-btn color="primary" dark small @click="dialog = true">
              <v-icon left>mdi-plus</v-icon>
              <span>Novo</span>
            </v-btn>
          </template>

          <v-text-field
            outlined
            v-model="form.descricao"
            label="Descrição*"
            autofocus
            :error-messages="errorDescricao"
            @input="$v.form.descricao.$touch()"
            @blur="$v.form.descricao.$touch()"
          ></v-text-field>

          <v-text-field
            outlined
            v-model="form.sigla"
            label="Sigla*"
            maxLength="4"
            :error-messages="errorSigla"
            @input="$v.form.sigla.$touch()"
            @blur="$v.form.sigla.$touch()"
            @keypress="errorSiglaUnica = false"
          ></v-text-field>

          <v-text-field
            v-model="form.color"
            label="Cor*"
            v-mask="maskColor"
            hide-details
            class="ma-0 pa-0"
            outlined
            :error-messages="errorColor"
            @input="$v.form.color.$touch()"
            @blur="$v.form.color.$touch()"
            @keypress="errorColorUnica = false"
          >
            <template v-slot:append>
              <v-menu
                v-model="menu"
                top
                nudge-top="35"
                nudge-left="306"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on }">
                  <div :style="swatchStyle" v-on="on" />
                </template>

                <v-card>
                  <v-card-text class="pa-0">
                    <v-color-picker
                      v-model="form.color"
                      flat
                      swatches-max-height="350"
                      width="300px"
                      hide-canvas
                      hide-sliders
                      hide-inputs
                      show-swatches
                      :swatches="swatchesArray"
                    />
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>
          </v-text-field>

          <Horarios v-model="form.horarios" class="mt-5" :color="errorHorarios ? 'error' : 'primary'" />
          <span v-if="errorHorarios" class="font-11 ml-2 pt-1 text-red-1600">{{ errorHorarios }}</span>
        </SysDialog>
      </v-toolbar>
    </template>

    <template #item.horarios="{ item }">
      <div class="d-flex">
        <v-chip
          v-for="horario in item.horarios"
          :key="horario"
          small
          class="ml-2px"
          v-text="`${horario}h`"
        />
      </div>
    </template>

    <template v-slot:item.action="{ item }">
      <v-btn
        icon
        title="Editar Grupo Separacao"
        class="mr-2"
        @click="editar(item)"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-btn icon title="Remover Grupo Separacao" @click="excluir(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>

    <template v-slot:item.color="{ item }">
      <v-icon :color="item.color">mdi-flag</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import DrpAPI from "@/api/drp.js";
import { mask } from "vue-the-mask";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import Horarios from "@/components/drp/configDrpAutomatizado/GrupoSeparacao/Horarios.vue";

export default {
  components: {Horarios, SysDialog},
  directives: { mask },
  data() {
    return {
      menu: false,
      maskColor: {
        mask: "#XXXXXX",
        tokens: {
          X: {
            pattern: /[0-9a-zA-Z]/,
            transform: (v) => v.toLocaleUpperCase(),
          },
        },
      },
      sw: [
        "#000000",
        "#696969",
        "#808080",
        "#A9A9A9",
        "#C0C0C0",
        "#D3D3D3",
        "#DCDCDC",
        "#6A5ACD",
        "#483D8B",
        "#191970",
        "#000080",
        "#00008B",
        "#0000CD",
        "#0000FF",
        "#6495ED",
        "#4169E1",
        "#1E90FF",
        "#00BFFF",
        "#87CEFA",
        "#87CEEB",
        "#ADD8E6",
        "#4682B4",
        "#B0C4DE",
        "#708090",
        "#778899",
        "#00FFFF",
        "#00CED1",
        "#40E0D0",
        "#48D1CC",
        "#20B2AA",
        "#008B8B",
        "#7FFFD4",
        "#66CDAA",
        "#5F9EA0",
        "#2F4F4F",
        "#00FA9A",
        "#00FF7F",
        "#98FB98",
        "#90EE90",
        "#8FBC8F",
        "#3CB371",
        "#2E8B57",
        "#006400",
        "#008000",
        "#228B22",
        "#32CD32",
        "#F0E68C",
        "#7CFC00",
        "#7FFF00",
        "#ADFF2F",
        "#9ACD32",
        "#6B8E23",
        "#556B2F",
        "#808000",
        "#BDB76B",
        "#DAA520",
        "#B8860B",
        "#8B4513",
        "#A0522D",
        "#BC8F8F",
        "#CD853F",
        "#D2691E",
        "#F4A460",
        "#FFDEAD",
        "#F5DEB3",
        "#DEB887",
        "#D2B48C",
        "#7B68EE",
        "#9370DB",
        "#8A2BE2",
        "#4B0082",
        "#9400D3",
        "#9932CC",
        "#BA55D3",
        "#800080",
        "#8B008B",
        "#FF00FF",
        "#EE82EE",
        "#DA70D6",
        "#DDA0DD",
        "#C71585",
        "#FF1493",
        "#FF69B4",
        "#C71585",
        "#FFB6C1",
        "#FFC0CB",
        "#F08080",
        "#CD5C5C",
        "#DC143C",
        "#800000",
        "#8B0000",
        "#B22222",
        "#A52A2A",
        "#FA8072",
        "#E9967A",
        "#FFA07A",
        "#FF7F50",
        "#FF6347",
        "#FF0000",
        "#FF4500",
        "#FF8C00",
        "#FFA500",
        "#FFD700",
        "#FFFF00",
      ],
      swatches: [],
      header: [
        { text: "#", value: "id", width: "80px", align: "center" },
        { text: "Descrição", value: "descricao" },
        { text: "Flag", value: "color" },
        { text: "Sigla", value: "sigla" },
        { text: "Horários", value: "horarios", width: "120px" },
        { text: "Data de Cadastro", value: "data_cadastro", width: "120px" },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "120px",
          align: "right",
        },
      ],
      gruposeparacoes: [],
      search: "",
      dialog: false,
      title: "Novo Grupo de Separacao",
      form: {
        id: "",
        descricao: "",
        sigla: "",
        color: "",
        horarios: []
      },
      errorSiglaUnica: false,
      errorColorUnica: false,
    };
  },
  validations: {
    form: {
      descricao: { required },
      sigla: {
        required,
        maxLength: maxLength(4),
        unique() {
          if (this.errorSiglaUnica) return false;
          else return true;
        },
      },
      color: {
        required,
        unique() {
          if (this.errorColorUnica) return false;
          else return true;
        },
        invalid() {
          const color = this.form.color;
          let aux = "";
          this.swatches.find((c) => {
            if (c == color) {
              aux = color;
            }
          });
          if (!aux) return false;
          else return true;
        },
      },
      horarios: {
        required,
      }
    },
  },
  computed: {
    errorDescricao() {
      const errors = [];
      if (!this.$v.form.descricao.$dirty) return errors;
      !this.$v.form.descricao.required &&
      errors.push("A descrição é obrigatório.");
      return errors;
    },
    errorSigla() {
      const errors = [];
      if (!this.$v.form.sigla.$dirty) return errors;
      !this.$v.form.sigla.required && errors.push("A sigla é obrigatório.");
      !this.$v.form.sigla.maxLength && errors.push("A sigla com 4 caracteres.");
      !this.$v.form.sigla.unique && errors.push("A sigla já é cadastrada");
      return errors;
    },
    errorColor() {
      const errors = [];
      if (!this.$v.form.color.$dirty) return errors;
      !this.$v.form.color.required && errors.push("A cor é obrigatório.");
      !this.$v.form.color.invalid && errors.push("A cor é invalida.");
      !this.$v.form.color.unique && errors.push("A cor já é cadastrada");
      return errors;
    },
    errorHorarios() {
      if (!this.$v.form.horarios.$dirty) return '';
      if (!this.$v.form.horarios.required) return 'O Horário é obrigatório.';
      return '';
    },
    swatchStyle() {
      const { menu } = this;
      const color = this.form.color;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: menu ? "50%" : "4px",
        transition: "border-radius 200ms ease-in-out",
      };
    },
    swatchesArray() {
      return [this.swatches];
    },
    ALTURA_TABELA() {
      const altura_config = '255px';
      const altura_parametrizacao = '230px';

      return this.$route.meta.layout == 'parametrizacao' ? `calc(100vh - ${altura_parametrizacao})` : `calc(100vh - ${altura_config})`;
    }
  },
  created() {
    this.listar();
  },
  methods: {
    listar() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        idLogado: localStorage.getItem("id"),
      };

      this.$store.dispatch("loading/addRequisicao",
        DrpAPI.getGrupoSeparacao(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            if (response.status == 200) {
              this.gruposeparacoes = response.data.gruposeparacao;
              this.gruposeparacoes.forEach((g) => {
                this.swatches = this.swatches.filter((s) => s != g.color);
              });
              this.randomColor();
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    excluir(item) {
      if (confirm("Deseja remover aplicativo?")) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = item.id;

        this.$store.dispatch("loading/addRequisicao",
          DrpAPI.deleteGrupoSeparacao(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              if (response.status == 200) {
                this.listar();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    editar(prop) {
      this.form.id = prop.id;
      this.form.descricao = prop.descricao;
      this.form.color = prop.color;
      this.form.sigla = prop.sigla;
      this.form.horarios = [...prop.horarios];
      this.title = "Editar Grupo de Separacao";
      this.dialog = true;
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.form;
        if (!params.id) {
          this.$store.dispatch("loading/addRequisicao",
            DrpAPI.createGrupoSeparacao(headers, params)
              .then((response) => {
                const token = response.data.token;
                localStorage.setItem("token", token);
                this.listar();
                this.fechar();
              })
              .catch((e) => {
                if (e.response.data.errors) {
                  this.errorSiglaUnica = true;
                  this.$v.$reset();
                  this.$v.$touch();
                } else {
                  this.Helpers.logout();
                }
              })
          );
        } else {
          this.$store.dispatch("loading/addRequisicao",
            DrpAPI.updateGrupoSeparacao(headers, params)
              .then((response) => {
                const token = response.data.token;
                localStorage.setItem("token", token);
                this.listar();
                this.fechar();
              })
              .catch((e) => {
                if (e.response.data.errors) {
                  this.errorSiglaUnica = true;
                  this.$v.$reset();
                  this.$v.$touch();
                } else {
                  this.Helpers.logout();
                }
              })
          );
        }
      }
    },
    fechar() {
      this.title = "Novo Grupo de Separacao";
      this.form = {
        id: "",
        descricao: "",
        sigla: "",
        color: "",
        horarios: [],
      };
      this.dialog = false;
      this.randomColor();
      this.$v.$reset();
    },
    randomColor() {
      this.form.color =
        this.swatches[Math.floor(Math.random() * this.swatches.length)];
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.swatches = [...this.sw];
        this.gruposeparacoes.forEach((g) => {
          if (g.id != this.form.id) {
            this.swatches = this.swatches.filter((s) => s != g.color);
          }
        });
        if (!this.form.id) {
          this.randomColor();
        }
      }
    },
  },
};
</script>
<style scope>
.input-descricao input,
.input-sigla input {
  text-transform: uppercase;
}
.v-color-picker__swatch .v-color-picker__color:nth-last-child(0),
.v-color-picker__swatch .v-color-picker__color:nth-last-child(1),
.v-color-picker__swatch .v-color-picker__color:nth-last-child(2) {
  display: none;
}
.v-color-picker__swatch {
  display: contents !important;
}
</style>
